import type {PublicMethodUtils} from '@wix/document-services-types'
import type {RemoteStructureMetaDataPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (
    publicMethodUtils: PublicMethodUtils
): PublicModuleDeclaration<RemoteStructureMetaDataPublicAPI> {
    const {extensionPublicAPI} = publicMethodUtils

    return {
        methods: {
            remoteStructureMetaData: {
                loadAll: extensionPublicAPI.immediate('remoteStructureMetaData.loadAll')
            }
        }
    }
}
